'use client';
import { ConverterWidget } from '@/app/[lang]/buy-crypto/components/ConverterWidget';
import classNames from 'classnames';
import buttons from '@/styles/button.module.scss';
import styles from './styles.module.scss';
import { useTranslations } from 'next-intl';
import { LinkBuyCrypto } from '@/blocks/components/PlatformLink';
import { BuyCryptoWidgetProvider } from '@/providers/BuyCryptoWidgetProvider';

type BuyCryptoTabContentProps = {
  token: string;
};

export function BuyCryptoTabContent({ token }: BuyCryptoTabContentProps) {
  const tr = useTranslations();

  return (
    <BuyCryptoWidgetProvider initialSelectedFiat={'USD'}>
      <ConverterWidget
        initialSelectedToken={token}
        renderCta={({ selectedToken, selectedFiat, payAmount }) => (
          <LinkBuyCrypto
            from={selectedFiat}
            to={selectedToken}
            amountFrom={payAmount}
            className={classNames(buttons.btn, buttons.btnS, buttons.btnPrimary, styles.actionButton)}
            data-event-label={tr('en.pages.buyCrypto.converterWidget.title', { coinTicker: selectedToken })}
          >
            {tr('pages.buyCrypto.converterWidget.title', { coinTicker: selectedToken })}
          </LinkBuyCrypto>
        )}
      />
    </BuyCryptoWidgetProvider>
  );
}
